import { SCHEMA_VERSIONS } from "../constants/schemaVersions";
import { assertArray, assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { nowIso } from "../utils/timestamps";

export const createVessel = ({
  id = createUuid(),
  organizationId,
  name,
  imoNumber = "",
  callSign = "",
  vesselType = "",
  enabledModules = [],
  createdAt = nowIso(),
  updatedAt = createdAt,
  schemaVersion = SCHEMA_VERSIONS.VESSEL,
}) => {
  assertString(id, "vessel.id");
  assertString(organizationId, "vessel.organizationId");
  assertString(name, "vessel.name");
  assertArray(enabledModules, "vessel.enabledModules");

  return {
    id,
    organizationId,
    name,
    imoNumber: imoNumber || undefined,
    callSign: callSign || undefined,
    vesselType: vesselType || undefined,
    enabledModules,
    createdAt,
    updatedAt,
    schemaVersion,
  };
};
